import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    const url = event.target.value
    const action = event.target.dataset.turboAction || "advance"

    if (url) {
      Turbo.visit(url, { action: action })
    }
  }
}
